__turbopack_context__.v({
  "control": "bxDtha_control",
  "ellipsis": "bxDtha_ellipsis",
  "nav": "bxDtha_nav",
  "page": "bxDtha_page",
  "pageActive": "bxDtha_pageActive",
  "pageIdle": "bxDtha_pageIdle",
  "pages": "bxDtha_pages",
  "step": "bxDtha_step",
  "stepDisabled": "bxDtha_stepDisabled",
  "stepEnabled": "bxDtha_stepEnabled",
});
